// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__1F1aX","fill":"Image_fill__1lxRr","contain":"Image_contain__1QNeS","cover":"Image_cover__2PBct"};